module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/informacje-podstawowe-b9b6e168.png";